export default (wrapperId, canvasId) => {
  global.$(wrapperId).html('');
  global.$(wrapperId).html(`<div><canvas dir="ltr" id="${canvasId}"></canvas></div>`); // eslint-disable-line i18next/no-literal-string
};
